<template>
  <div class="tva-checkbox">
    <div
      :class="['tva-checkbox-item', { checked: isItemChecked(index) }]"
      v-for="(item, index) in content"
      @click="toggleItem(index)"
      :key="index"
    >
      <svgicon
        v-if="item.active"
        class="check"
        icon="actions-toggle-checkbox-checked-filled"
        width="20"
        height="20"
      ></svgicon>
      <svgicon
        v-if="!item.active"
        class="check"
        icon="actions-toggle-checkbox"
        width="20"
        height="20"
      ></svgicon>
      {{ item.label }}
    </div>
  </div>
</template>
<script>
import "@/compiled-icons/actions-toggle-checkbox-checked-filled";
import "@/compiled-icons/actions-toggle-checkbox";
export default {
  props: ["content"],
  data() {
    return {
      openSections: new Set([])
    };
  },
  methods: {
    toggleItem(index) {
      let tmpContent = _.clone(this.content);
      tmpContent[index].active = !tmpContent[index].active;
      this.content = _.clone(tmpContent);
      this.$emit("click", this.content);
    },
    isItemChecked(index) {
      return !this.openSections.has(index);
    }
  }
};
</script>
<style lang="scss" scoped>
.tva-checkbox {
  .tva-checkbox-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    width: fit-content;
    .check {
      margin-right: 0.5em;
    }
  }
}
</style>
